/*
 *
 * ForgotPasswordPage reducer
 *
 */

import {
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_SUCCESS,
  REQUEST_ANOTHER,
  REQUEST_FORM,
  REQUEST_SUCCESS,
  REDIRECT_TO_SIGN_IN,
  SET_COMPONENT_TO_RENDER,
  RESET_FORGOT_PASSWORD_STATE,
  HAS_RPS_PASSWORD_ERROR,
  HAS_RPS_VALID_PASSWORD,
} from "./constants";

const initialState = {
  componentToRender: REQUEST_FORM,
  hasRpsPasswordError: true,
};

function forgotPasswordPageReducer(state = initialState, action) {
  switch (action.type) {
    case PASSWORD_RESET_REQUEST_SUCCESS:
      return {
        ...state,
        componentToRender: REQUEST_SUCCESS,
      };
    case PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        componentToRender: REDIRECT_TO_SIGN_IN,
      };
    case SET_COMPONENT_TO_RENDER:
      return {
        ...state,
        componentToRender: action.payload,
      };
    case HAS_RPS_VALID_PASSWORD:
      return {
        ...state,
        hasRpsPasswordError: false,
      };
    case HAS_RPS_PASSWORD_ERROR:
      return {
        ...state,
        hasRpsPasswordError: true,
      };
    case REQUEST_ANOTHER:
      return initialState;
    case RESET_FORGOT_PASSWORD_STATE:
      return initialState;
    default:
      return state;
  }
}

export default forgotPasswordPageReducer;
